import { useState, useEffect } from 'react';
import { MapMode } from '../types';
import { ESRI_ALTERNATIVE_BASEMAPS, ESRI_BASEMAPS } from '../configurations';
import { useThemeStore } from '~/theme/use-theme-store';

/**
 * Hook that returns the image URL for the map mode toggle button.
 * Returns the image for the map mode that the user can switch to (not the current mode).
 *
 * @param mapMode - The current map mode
 * @param isAlternativeBasemap - Whether to use alternative basemaps
 * @returns The image URL for the toggle button
 */

export const useCurrentMapModeImage = (
    mapMode: MapMode,
    isAlternativeBasemap?: boolean
): string => {
    const [currentMapModeImage, setCurrentMapModeImage] = useState<string>('');
    const { theme } = useThemeStore();


    useEffect(() => {
        const basemaps = isAlternativeBasemap ? ESRI_ALTERNATIVE_BASEMAPS : ESRI_BASEMAPS;

        let imageUrl = '';

        if(mapMode === 'SATELLITE_MODE' && theme === 'light'){
            imageUrl = basemaps.LIGHT.image;
        } else if(mapMode === 'SATELLITE_MODE' && theme === 'dark'){
            imageUrl = basemaps.DARK.image;
        } else {
            imageUrl = basemaps.SATELLITE.image;
        }

        // // This is used to exclude the inactive theme from the proceeding search.
        // const inactiveMapMode = theme === 'dark' ? 'LIGHT_MODE' : 'DARK_MODE';

        // // We toggle between satellite and non-satellite maps.  When in non-satellite map, the mapmode could be light or dark.
        // const imageUrl =
        //     Object.values(basemaps).find(
        //         (basemapInfo) => basemapInfo.mode !== mapMode && basemapInfo.mode !== inactiveMapMode
        //     )?.image ?? '';

        setCurrentMapModeImage(imageUrl);
    }, [mapMode, isAlternativeBasemap, theme]);

    return currentMapModeImage;
};
